export default __webpack_public_path__ + "static/media/banner.7ba196b4.png";